import gql from "graphql-tag";

export default gql`
  query GetDataQualityReview {
    getDataQualityReview {
      tenantId
      objectId
      environment
      as_of_date
      data_kind
      data_label
      writes_enabled
      coverage_summary
      provenance
      items {
        scope {
          requirement
          root_cause
          action_id
          severity
          evidence_fingerprint
          details
          outputs
        }
        action {
          requirement
          root_cause
          action_id
          severity
          evidence_fingerprint
          details
          outputs
        }
        decision {
          environment
          requirement
          root_cause
          version
          decision
          reason
          owner
          actor
          reviewed_at
          review_on
          expires_on
          observed_action {
            requirement
            root_cause
            action_id
            severity
            evidence_fingerprint
            details
            outputs
          }
        }
        state
        review_due
        evidence
        history {
          before {
            environment
            requirement
            root_cause
            version
            decision
            reason
            owner
            actor
            reviewed_at
            review_on
            expires_on
            observed_action {
              requirement
              root_cause
              action_id
              severity
              evidence_fingerprint
              details
              outputs
            }
          }
          after {
            environment
            requirement
            root_cause
            version
            decision
            reason
            owner
            actor
            reviewed_at
            review_on
            expires_on
            observed_action {
              requirement
              root_cause
              action_id
              severity
              evidence_fingerprint
              details
              outputs
            }
          }
        }
      }
    }
  }
`;
